import * as React from 'react';
import { History } from 'history';
import Model from './user-model';
import BaseList from '../base/base-list.component';
import AppService from '../../services/app.service';

interface IProps {  
  history: History;
  root?: string;
  actions?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
}

interface IState {
}

export default class UserList extends React.Component<IProps, IState> {
  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} url={(this.props.root || '') + Model.url}  endPointFilter={AppService.isAppFullVersion()? '': Model.endPointFilterList()} model={Model} actions={this.props.actions || ['...','share']} searchField='name' disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
